import classNames from 'classnames';
import { useMemo } from 'react';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/partials/hangman-response.module.scss';

interface HangmanResponseProps {
    word?: string | null;
    className?: string | null;
}

function HangmanResponse({ word = null, className = null }: HangmanResponseProps) {
    const themeClassName = useThemeClassName(styles);
    const finalWord = useMemo(() => (word || '').split(''), [word]);
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            {(finalWord || []).map((letter, i) => (
                <div
                    key={`letter-${letter}-${i + 1}`}
                    className={classNames([
                        styles.letter,
                        'game-letter',
                        {
                            [styles.empty]: letter === ' ',
                        },
                    ])}
                >
                    {letter}
                </div>
            ))}
        </div>
    );
}

export default HangmanResponse;
